import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/faq/capture')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/faq/capture"!</div>
}
